module.exports = __webpack_public_path__ + "img/banner.ed1322df.jpg";